<template>
  <v-clamp autoresize :max-lines="maxLines" class="clamp-container">
    <template>
      {{ text }}
    </template>
    <template v-slot:after="{ toggle, expanded, clamped }">
      <a-button v-if="expanded || clamped" type="link" class="link" @click="toggle">{{ expanded ? '收起' : '展开' }}</a-button>
    </template>
  </v-clamp>
</template>
<script>
import VClamp from 'vue-clamp';
export default {
  components: {
    VClamp
  },
  props: {
    text: {
      type: String,
      default: ''
    },
    maxLines: {
      type: Number,
      default: 2
    }
  }
};
</script>
<style lang="less" scoped>
.clamp-container {
  @media only screen and (max-width: 800px) {
    max-width: 70px;
  }
  @media only screen and (min-width: 800px) {
    max-width: 300px;
  }
  .link {
    padding: 0 5px;
  }
}
</style>
